import i18next from '../strings/i18n/i18n';
import responseCodes from '../const/responseCodes';
var getErrorBodyText = function (errorCode) {
    var tmpErrorBody = "".concat(i18next.t('errorPage.default'));
    if (errorCode === "".concat(responseCodes.BAD_REQUEST))
        tmpErrorBody = "".concat(i18next.t('errorPage.fourHundred'));
    if (errorCode === "".concat(responseCodes.INTERNAL_SERVER_ERROR))
        tmpErrorBody = "".concat(i18next.t('errorPage.fiveHundred'));
    return "".concat(tmpErrorBody);
};
export default getErrorBodyText;
